import { useEffect, useState, type RefObject } from 'react';
import type { Viewport } from '../camera';

/** Live element size via ResizeObserver; `fallback` until measured (and always in jsdom). */
export function useElementSize(ref: RefObject<Element | null>, fallback: Viewport): Viewport {
  const [size, setSize] = useState<Viewport>(fallback);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return;
    const ro = new ResizeObserver(([entry]) => {
      const { width, height } = entry.contentRect;
      if (width > 0 && height > 0) setSize({ width: Math.round(width), height: Math.round(height) });
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, [ref]);
  return size;
}
